const switchSliderTokens = ({ colors, space }) => ({
  colors: {
    bg: colors.neutral['0'],
    borderColor: colors.neutral['50'],
    checkedBg: colors.primary['50'],
    checkedBorderColor: colors.primary['50'],
    activeBg: colors.primary['50'],
    checkedVersionBBG: colors.neutrals.light,
    ghost: {
      bg: colors.neutral['0'],
      checkedVersionBBG: colors.neutral['20'],
      checkedBorderColor: colors.primary['30'],
      borderColor: colors.neutral['50'],
      offColor: colors.neutral['50'],
    },
  },
  space: {
    left: '0',
    checkedLeft: `-${space[1]}px`,
  },
  sizes: {
    medium: {
      width: '40px',
      height: `${space[5]}px`,
      bubbleSize: `${space[5]}px`,
    },
  },
});

export default switchSliderTokens;
